export default __webpack_public_path__ + "static/media/monthly-plan-illustration.d6e1abd0.svg";